import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const UsersCard = ({ icon: Icon, title, count, timeRange, setTimeRange }) => {
  return (
    <Box
      border={2}
      borderColor="#CD9D4126"
      bgcolor="white"
      borderRadius="12px"
      py={2}
      px={1.3}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box >
          {Icon && (
            typeof Icon === "string" ? (
              <img
                src={Icon}
                alt=""
                style={{  display: "flex", alignItems: "center", height: "40px", width: "50px" }}
              />
            ) : (
              <Icon style={{ height: "24px", width: "24px" }} />
            )
          )}
        </Box>
        <Select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          size="small"
          variant="outlined"
          sx={{
            fontSize: "14px",
            bgcolor: "transparent",
            height: "32px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              padding: "4px 8px",
            },
          }}
        >
          <MenuItem value="this day">Heute</MenuItem>
          <MenuItem value="this week">Diese Woche</MenuItem>
          <MenuItem value="this month">Diesen Monat</MenuItem>
        </Select>
      </Box>
      <Box ml={1}>
        <Typography mt={2} fontWeight="400" fontSize="18px">
          {title}
        </Typography>
        <Typography mt={2} color="#CD9D41" fontWeight="500" fontSize="20px">
          {count}
        </Typography>
      </Box>
    </Box>
  );
};

export default UsersCard;